import React from 'react';
import { Link } from 'react-router-dom';
import { Link as StencilLink } from '@amzn/stencil-react-components/link';


const BaseRouterLink = (props) => (
    <Link {...props} />
);

export const PageRouterLink = StencilLink.withComponent(BaseRouterLink);